export default function SciPy_Quiz() {
  return (
    <div>
      <h1>SciPy Quiz</h1>
    </div>
  );
}
